import colors from 'vuetify/lib/util/colors'
export default {
  computed: {
    institution: {
      get() {
        return this.$institution.institution
      },
      set(value) {
        this.$institution.institution = value
      }
    },
    hasInstitution: {
      get() {
        return Object.keys(this.institution).length !== 0
      }
    },
    institutionId: {
      get() {
        return this.hasInstitution ? this.institution.institutionId : 0
      }
    },
    shortFriendlyAddress: {
      get() {
        return this.hasInstitution && this.institution.contactAddress && this.institution.contactAddress.shortFriendlyAddress
      }
    },
    hasExtraAttributes: {
      get() {
        return this.hasInstitution && this.institution.extraAttributes
      }
    },
    institutionTaC: {
      get() {
        return this.hasExtraAttributes ? this.institution.extraAttributes['instTermsAndConds'] : null
      }
    },
    institutionLogo: {
      get() {
        return this.hasExtraAttributes && this.institution.extraAttributes.instLogo ? this.institution.extraAttributes['instLogo'] : null
      }
    },
    institutionLogoHead: {
      get() {
        return this.hasExtraAttributes && this.institution.extraAttributes.instLogoHead ? this.institution.extraAttributes['instLogoHead'] : null
      }
    },
    institutionLogoBW: {
      get() {
        return this.hasExtraAttributes && this.institution.extraAttributes.instLogoBw ? this.institution.extraAttributes['instLogoBw'] : null
      }
    },
    instDativDesc: {
      get() {
        return this.hasExtraAttributes ? this.institution.extraAttributes['instDativDesc'] : (this.hasInstitution ? this.institution.institutionDesc : null)
      }
    },
    instAboutAgreement: {
      get() {
        return this.hasExtraAttributes ? this.institution.extraAttributes['instAboutAgreement'] : null
      }
    },
    instRegistrationAppUrl: {
      get() {
        return this.hasExtraAttributes ? this.institution.extraAttributes['registrationAppUrl'] : null
      }
    },
    instHomepage: {
      get() {
        return this.hasExtraAttributes ? this.institution.extraAttributes['instHomepage'] : null
      }
    },
    instPrimary: {
      get() {
        return this.hasExtraAttributes && this.institution.extraAttributes.instPrimary ? this.institution.extraAttributes['instPrimary'] : this.$vuetify.theme.themes[this.instTheme].primary
      }
    },
    instSecondary: {
      get() {
        return this.hasExtraAttributes && this.institution.extraAttributes.instSecondary ? this.institution.extraAttributes['instSecondary'] : colors.blue.lighten4
      }
    },
    instTheme: {
      get() {
        return this.hasExtraAttributes && this.institution.extraAttributes.instTheme ? this.institution.extraAttributes['instTheme'] : 'light'
      }
    }
  }
}
